import { EventSpecs, SessionData } from '@chegg/analytics-frontend'
import { Product } from '@chegg/analytics-frontend/lib/initializer'
import { Site } from '../types'

export interface Event extends EventSpecs {
  pageType?: string
}

export type WtaState = Pick<SessionData, 'authState' | 'subscriptionStatus'>

export const CHEGG_PRODUCT = 'chegg_writing'
export const EASYBIB_PRODUCT = 'easybib_plus'
export const BIBME_PRODUCT = 'bibme_plus'
export const CITATION_MACHINE_PRODUCT = 'citation_machine_plus'

export type ProductMap = { [key in Site]: Product }
